import React, { useState } from "react";

import Servicesbanner from '../Servicesbanner';
import Servicescontent from '../Servicescontent';
import Testimonials from '../Testimonials';
import Servicesstep from '../Servicesstep';

const Effortlessglobalpayments = () => {

  const [steps, setSteps] = useState([
    { 
      stepNumber: 1,
      stepbadgeText: "Step 1", 
      steptitle: "Submit a Request", 
      steptext: "Start by clicking “Get a Transfer Quote” and complete a short webform with the amount, senders’ currency, and recipient currency.",
      stepimageSrc: "../Images/number-1.png"
    },
    { 
      stepNumber: 2,
      stepbadgeText: "Step 2", 
      steptitle: "Get a Quote", 
      steptext: "We’ll calculate the exchange rate and any applicable transfer fees, then send you a quote with the final amount your recipient will receive.",
      stepimageSrc: "../Images/number-2.png"
    },
    { 
      stepNumber: 3,
      stepbadgeText: "Step 3", 
      steptitle: "Approve the Transfer", 
      steptext: "Review and approve the quote. Once confirmed, make your payment and submit any necessary documentation.",
      stepimageSrc: "../Images/number-3.png"
    },
    { 
      stepNumber: 4,
      stepbadgeText: "Step 4", 
      steptitle: "Transfer Processing", 
      steptext: "We process your transfer. Your recipient will receive the funds directly in their account.",
      stepimageSrc: "../Images/number-4.png"
    },
    { 
      stepNumber: 5,
      stepbadgeText: "Step 5", 
      steptitle: "Transaction Confirmation", 
      steptext: "Once the transfer is complete, we’ll send you a confirmation, including a transaction receipt.",
      stepimageSrc: "../Images/number-5.png"
    }
  ]);

  return (
    <>
      <Servicesbanner 
        title="Effortless" 
        highlight="Global Payments" 
        />
      <Servicescontent 
        conttitle="Easy Global Payments" 
        content={<><p>Easily pay international suppliers in major currencies like USD, CNY, CAD, EUR, NGN, GBP, INR, and VND.</p><p>Send money to countries including china, the USA, Canada, Europe, the UK, India, Singapore, Nigeria, Vietnam, and more.</p><p>Our cross-border transfer service is fast, reliable, and cost-effective. Whether you're supporting family, covering business expenses, or paying for tuition or real estate, we make global transfers simple. Enjoy competitive exchange rates and transparent fees with no surprises.</p></>}
        buttonlink="#"
        label="Get a Transfer Quote"
      />
      <Servicesstep 
        steps={steps} 
      />
      <Testimonials />
    </>
  );
}

export default Effortlessglobalpayments;
